"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueStatusCountChips = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const IssueStatus_1 = __importStar(require("@opsbase/lib-issue/IssueStatus"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const react_1 = __importDefault(require("react"));
const styles = {
    width: 18,
    height: 18,
    marginRight: 2,
    color: 'white',
    lineHeight: '18px',
    fontSize: 10,
    textAlign: 'center',
    borderRadius: '50%',
};
function IssueStatusCountChips(props) {
    const { issues, onClick, style } = props;
    const n = issues.filter(i => i.status === IssueStatus_1.default.NEW).length;
    const p = issues.filter(i => i.status !== IssueStatus_1.default.NEW && i.status !== IssueStatus_1.default.CLOSED).length;
    const c = issues.filter(i => i.status === IssueStatus_1.default.CLOSED).length;
    return (react_1.default.createElement(Horizontal_1.default, { centered: true, justify: "flex-start", style: style, onClick: onClick },
        n > 0 && (react_1.default.createElement(Pane_1.default, { style: Object.assign(Object.assign({}, styles), { backgroundColor: (0, IssueStatus_1.issueStatusColor)(IssueStatus_1.default.NEW).main }) },
            react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('x-y-issues', { x: n, y: (0, IssueStatus_1.issueStatusLabel)(IssueStatus_1.default.NEW) }) }, n))),
        p > 0 && (react_1.default.createElement(Pane_1.default, { style: Object.assign(Object.assign({}, styles), { backgroundColor: (0, IssueStatus_1.issueStatusColor)(IssueStatus_1.default.IN_PROGRESS).main }) },
            react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('x-y-issues', {
                    x: p,
                    y: (0, IssueStatus_1.issueStatusLabel)(IssueStatus_1.default.IN_PROGRESS),
                }) }, p))),
        c > 0 && (react_1.default.createElement(Pane_1.default, { style: Object.assign(Object.assign({}, styles), { backgroundColor: (0, IssueStatus_1.issueStatusColor)(IssueStatus_1.default.CLOSED).main }) },
            react_1.default.createElement(Tooltip_1.default, { tip: lib_i18n_1.default.t('x-y-issues', {
                    x: c,
                    y: (0, IssueStatus_1.issueStatusLabel)(IssueStatus_1.default.CLOSED),
                }) }, c)))));
}
exports.IssueStatusCountChips = IssueStatusCountChips;
exports.default = IssueStatusCountChips;
